import { useQueries } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { getReservationType } from 'modules/accommodations/features/reservations/api';

export const useQueryRelatedCalculations = (calculationIds: string[]) => {
  const relatedCalculationsQueries = useQueries(
    calculationIds.map(calculationId => ({
      queryKey: [QUERY_KEYS.UNITS_RESERVATION_TYPE, calculationId, 'REZ'],
      queryFn: () => getReservationType(calculationId, 'REZ'),
    })),
  );

  return {
    relatedCalculations: relatedCalculationsQueries.map(({ data }) => data),
    isLoadingRelatedCalculations: relatedCalculationsQueries.some(({ isLoading }) => isLoading),
  };
};
